import { PrimaryRoutes } from '../enums/internal-route-enums';
import { Page } from '../enums/page-enums';

const MAIN_MENU_PAGE_ROUTE_MAP: Record<string, PrimaryRoutes> = {
	[Page.Dashboard]: PrimaryRoutes.Home,
	[Page.DataInsights]: PrimaryRoutes.DataInsights,
	[Page.CXInsights]: PrimaryRoutes.CXInsights,
	[Page.OpsInsights]: PrimaryRoutes.OpsInsights,
	[Page.AIAnalyst]: PrimaryRoutes.AIAnalyst,
	[Page.Campaigns]: PrimaryRoutes.Campaigns,
	[Page.Segments]: PrimaryRoutes.Segments,
	[Page.Contacts]: PrimaryRoutes.Contacts,
	[Page.Settings]: PrimaryRoutes.Settings,
	[Page.CRMInsights]: PrimaryRoutes.CRMInsights,
	[Page.ProfitInsights]: PrimaryRoutes.ProfitInsights,
	[Page.D2CDashboard]: PrimaryRoutes.D2CDashboard,
	[Page.RetailDashboard]: PrimaryRoutes.RetailDashboard,
	[Page.ConversionInsights]: PrimaryRoutes.ConversionInsights,
	[Page.ProductInsights]: PrimaryRoutes.ProductInsights,
	[Page.Acquisition]: PrimaryRoutes.Acquisition,
	[Page.Retention]: PrimaryRoutes.Retention,
	[Page.Subscription]: PrimaryRoutes.Subscription,
	[Page.Customer]: PrimaryRoutes.Customer,
	[Page.CACSignals]: PrimaryRoutes.CACSignals,
	[Page.LTVSignals]: PrimaryRoutes.LTVSignals,
	[Page.ConversionSignals]: PrimaryRoutes.ConversionSignals,
	[Page.ExperienceSignals]: PrimaryRoutes.ExperienceSignals,
	[Page.PerformanceSignals]: PrimaryRoutes.PerformanceSignals,
	[Page.GrowthModel]: PrimaryRoutes.GrowthModel,
	[Page.JourneyExplorer]: PrimaryRoutes.JourneyExplorer,
}

const MAIN_MENU_DEFAULT_PAGE_ORDER: Page[] = [
	Page.Dashboard,
	Page.DataInsights,
	Page.D2CDashboard,
	Page.RetailDashboard,
	Page.Acquisition,
	Page.ConversionInsights,
	Page.Retention,
	Page.Subscription,
	Page.Customer,
	Page.ProductInsights,
	Page.CXInsights,
	Page.CRMInsights,
	Page.Campaigns,
	Page.ProfitInsights,
	Page.GrowthModel,
	Page.JourneyExplorer,
	Page.Segments,
	Page.Contacts,
	Page.CACSignals,
	Page.LTVSignals,
	Page.ConversionSignals,
	Page.ExperienceSignals,
	Page.PerformanceSignals,
	Page.OpsInsights,
	Page.AIAnalyst,
	Page.Settings,
];

export function getFirstAvailableMainMenuPage(permittedPages: string[]): Page | null {
	for (const page of MAIN_MENU_DEFAULT_PAGE_ORDER) {
		const route = MAIN_MENU_PAGE_ROUTE_MAP[page];
		if (route && permittedPages.includes(page)) {
			return page;
		}
	}
	return null;
}

export function getFirstAvailableMainMenuRoute(permittedPages: string[]): PrimaryRoutes {
	const page = getFirstAvailableMainMenuPage(permittedPages);
	if (page) {
		return MAIN_MENU_PAGE_ROUTE_MAP[page];
	}
	return PrimaryRoutes.Home;
}

function normalizePathname(pathname: string): string {
	if (!pathname || pathname === '/') {
		return '/';
	}
	return pathname.replace(/\/$/, '');
}

export function isNavigationItemActive(
	pathname: string,
	itemPage: Page | string,
	itemRoutes: PrimaryRoutes[],
	permittedPages: string[]
): boolean {
	if (!itemRoutes.length) {
		return false;
	}

	const normalizedPath = normalizePathname(pathname);

	if (normalizedPath === '/' || normalizedPath === '/home') {
		const homePage = getFirstAvailableMainMenuPage(permittedPages);
		return homePage !== null && itemPage === homePage;
	}

	return itemRoutes.some((route) => {
		const routePath = route.toString();
		return normalizedPath === routePath || normalizedPath.startsWith(`${routePath}/`);
	});
}

export function isOnMainMenuRoute(pathname: string, route: PrimaryRoutes): boolean {
	const normalizedPath = normalizePathname(pathname);
	const routePath = route.toString();

	if (route === PrimaryRoutes.Home) {
		return normalizedPath === '/dashboard' || normalizedPath === '/home' || normalizedPath === '/';
	}

	return normalizedPath === routePath || normalizedPath.startsWith(`${routePath}/`);
}
